import { useState } from 'react';

import { Navbar } from './components';
import { Hero, ProjectList, Archive, About, Contact } from './sections';

import './App.css';

export default function App() {
  const [view, setView] = useState('home');
  const [lang, setLang] = useState('pl');
  const [theme, setTheme] = useState('light');
  const toggleTheme = () => {
    setTheme(prev => prev === 'light' ? 'dark' : 'light');
  };

  return (
    <div className={`app-container theme-${theme}`}>

      <Navbar setView={setView} lang={lang} setLang={setLang} theme={theme} toggleTheme={toggleTheme} />

      {view === 'home' ? (
        <main>
          <Hero lang={lang} />
          <ProjectList setView={setView} lang={lang} />
          <About lang={lang} />
          <Contact lang={lang} />
        </main>
      ) : (
        <main>
          <Archive setView={setView} lang={lang} />
        </main>
      )}
    </div>
  );
}